<template>
  <span class="inline-flex items-center gap-1.5 flex-wrap">
    <span
      v-for="rel in anexosRelaciones"
      :key="rel.catId ?? rel.cianId"
      :ref="'ref-pdf-' + rel.cianId"
      :title="'Anexo #' + rel.cianId"
      class="inline-flex items-center rounded-md px-2 py-0.5 text-[10px] font-medium bg-purple-50 text-purple-700 ring-1 ring-inset ring-purple-600/10 dark:bg-purple-400/10 dark:text-purple-400"
    >
      ref-pdf-{{ rel.cianId }}
    </span>
    <ButtonDefault
      title="Ver anexos"
      type-style="outline"
      size="xs"
      color="blue"
      @click="showModal = true"
    >
      <PaperClipIcon class="shrink-0 size-4" />
    </ButtonDefault>
  </span>
  <AnexoViewerModal
    v-if="showModal"
    :citt-id="cittId"
    :anexos-relaciones="anexosRelaciones"
    @close="showModal = false"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { PaperClipIcon } from '@heroicons/vue/24/outline'
import type { IAnexoRelacion } from '@/modules/Asistencial/interfaces'
import ButtonDefault from '@/modules/Core/components/general/ButtonDefault.vue'
import AnexoViewerModal from '@/modules/Asistencial/components/AnexoViewerModal.vue'

defineProps<{
  cittId: number
  anexosRelaciones?: IAnexoRelacion[]
}>()

const showModal = ref(false)
</script>
